import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type { SponsoredProduct } from '../interfaces/sponsoredProduct';
import type { SponsoredProductsState } from '../model';

export const selectSponsoredProductsState = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): SponsoredProductsState | undefined =>
  state.productDiscovery?.sponsoredProducts;

export const selectSponsoredProductsItems = (
  state: SpartacuxProductDiscoveryDomainState,
): SponsoredProduct[] | undefined => selectSponsoredProductsState(state)?.items;

export const selectSponsoredProductsPositions = (
  state: SpartacuxProductDiscoveryDomainState,
): number[] => selectSponsoredProductsState(state)?.positions || [];

export const selectFetchingSponsoredProducts = (
  state: SpartacuxProductDiscoveryDomainState,
): boolean => !!selectSponsoredProductsState(state)?.fetching;
